"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileServices = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const TileServices = ({ servicesLabel, services }) => {
    if ((0, app_1.safe)(services).length > 0) {
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "inline-block mr-[15px]", children: [(0, jsx_runtime_1.jsxs)("span", { className: "inline-block font-semibold text-base text-primary mr-[5px]", children: [servicesLabel, ":"] }), (0, jsx_runtime_1.jsx)("div", { className: "inline mr-[5px] body-md text-primary", children: (0, app_1.safe)(services)
                            .filter(item => item.trim() !== '')
                            .join(', ') })] }) }));
    }
    return null;
};
exports.TileServices = TileServices;
